import {useMutation} from '@tanstack/react-query'

import Logger from 'services/Logger'
import {PoliciesService} from 'services/api'
import {BypassDataServerRequest} from 'interfaces'

export const UPDATE_BYPASS_QUERY_KEY = 'updateBypassData'

interface UpdateBypassQueryProps {
  onSuccess: () => void
}

interface UpdateBypassParams {
  policyName: string
  payload: BypassDataServerRequest
}

export const useUpdateBypass = ({onSuccess}: UpdateBypassQueryProps) => {
  return useMutation(
    ({policyName, payload}: UpdateBypassParams) =>
      PoliciesService.updateBypass({
        policyName,
        data: payload,
      }),
    {
      onSuccess: onSuccess,
      onError: (error: Error) => {
        Logger.LogError(error)
      },
    },
  )
}
